import CustomSelect, { OpcaoDoCustomSelect } from 'components/custom-select';
import { FaseDoCiclo, fasesMensaisDoCiclo } from 'pages/RealizacaoDestaque/realizacoes-do-semestre';

/** Valor de "Todos os meses": nenhuma fase escolhida. */
export const TODOS_OS_MESES = '';

export function opcoesDeMes(fases: FaseDoCiclo[] | undefined): OpcaoDoCustomSelect[] {
  return [
    { value: TODOS_OS_MESES, label: 'Todos os meses' },
    ...fasesMensaisDoCiclo(fases).map(fase => ({ value: fase._id, label: fase.title })),
  ];
}

interface SeletorDeMesProps {
  /** Fases do ciclo (`cyclesExtended[].steps`); só as mensais viram opção (ciclos antigos, sem `type`: todas). */
  fases: FaseDoCiclo[] | undefined;
  /** `_id` da fase escolhida, ou `TODOS_OS_MESES`. */
  valor: string;
  onChange: (faseId: string) => void;
  /** Nome acessível: o mesmo texto do rótulo visível da tela. */
  rotulo: string;
  inputId: string;
}

/** Filtro por mês das listas do ciclo (AJ3-11, AJ3-31): "Todos os meses" primeiro e as fases mensais do ciclo. */
export default function SeletorDeMes({ fases, valor, onChange, rotulo, inputId }: SeletorDeMesProps) {
  const opcoes = opcoesDeMes(fases);

  return (
    <CustomSelect
      variant="light"
      options={opcoes}
      value={opcoes.find(opcao => opcao.value === valor) ?? opcoes[0]}
      onChange={opcao => opcao && onChange(String(opcao.value))}
      ariaLabel={rotulo}
      inputId={inputId}
    />
  );
}
